import { Divider } from '../sub-indicators.common.style';

export const Styled = {
  Divider,
};
